const jawazakTableStyle = (theme) => ({
	jawazakRadioButtons: {
		display: 'flex',
		padding: '16px 80px 0',
		flexDirection: 'column',
		'& label': {
			padding: 0,
		},
		[theme.breakpoints.down('sm')]: {
			padding: '0 40px',
		},
	},
});

export default jawazakTableStyle;
